module.exports = auth0;